import React from 'react';
import { FormattedMessage } from 'react-intl';

import env from 'Env';
import HpOmenVideoImgLoader from 'Components/Partners/HpOmenOasis/HpOmenVideoImgLoader';
import imgixConfig from 'Config/imgix';
import useViewport from 'Hooks/useViewport';
import 'Components/Partners/HpOmenOasis/HpOmenOasisBanner.scss';


const HpOmenOasisBanner = () => {
  const cdnUrl = env.cdnUrl;
  const { isBelowXxl, isBelowXl, isBelowLg, isBelowMd, isBelowSm } = useViewport();

  let imgSrc = `${cdnUrl}/assets/partners/hpomenoasis/HP_OMEN_Banner_2648x440-noimage-notext.png`;

  if (isBelowXxl) imgSrc = `${cdnUrl}/assets/partners/hpomenoasis/HP_OMEN_Banner_2248x400-noimage-notext.png?${imgixConfig}`;
  if (isBelowXl) imgSrc = `${cdnUrl}/assets/partners/hpomenoasis/HP_OMEN_Banner_1888x400_alt-notext-noimage.png?${imgixConfig}`;
  if (isBelowLg) imgSrc = `${cdnUrl}/assets/partners/hpomenoasis/HP_OMEN_Banner_1408x360-noimage-notext.png?${imgixConfig}`;
  if (isBelowMd) imgSrc = `${cdnUrl}/assets/partners/hpomenoasis/HP_OMEN_Banner_1048x458-noimage-notext2.png?${imgixConfig}`;
  if (isBelowSm) imgSrc = `${cdnUrl}/assets/partners/hpomenoasis/HP_OMEN_Banner_640x570-no-text2.png?${imgixConfig}`;

  return (
    <div className="hp-omen-oasis-banner faux-block-link">
      <div className="background-container">
        <img
          sizes="100vw"
          src={imgSrc}
          alt="hpomenoasisbanner"
          loading="lazy"
          className="img-background"
        />
      </div>

      <div className="banner-content">
        <a href="https://gaminghub.omen.com/invite?utm_source=Fanatical+Website&utm_medium=banner&utm_campaign=Oasis+Live+Fanatical+Banner" target="_blank" rel="noopener noreferrer" className="faux-block-link__overlay-link text-column-container">
          <div className="text-column-content">
            <div className="banner-text">
              <FormattedMessage
                id="hpomenoasisbanner.text.intro"
                defaultMessage="Download Oasis Live to connect with your friends while you play"
              />
            </div>
            <div className="button-container">
              <FormattedMessage id="hpomenoasisbanner.button.tryoasislive" defaultMessage="Try Oasis Live" />
            </div>
          </div>
        </a>

        <div className="video-container">
          <HpOmenVideoImgLoader
            cover="video-thumb.jpg"
            video="efZzKvxM1JQ"
          />
        </div>
      </div>
    </div>
  );
};

export default HpOmenOasisBanner;
